var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.957 511.957",
    height: 512,
    viewBox: "0 0 511.957 511.957",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m93.255 123.259h150.01v30h-150.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.255 183.262h150.01v30h-150.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.957 343.696c0-92.779-75.481-168.26-168.261-168.26-2.441 0-4.887.054-7.333.16.105-2.432.158-4.877.158-7.335 0-92.779-75.481-168.261-168.261-168.261-92.779 0-168.26 75.482-168.26 168.26 0 42.587 16.35 83.754 45.232 114.762l-32.631 53.499h155.659c2.458 0 4.903-.053 7.335-.158-.106 2.446-.16 4.892-.16 7.333 0 92.779 75.481 168.261 168.26 168.261h155.658l-32.631-53.499c28.884-31.008 45.235-72.175 45.235-114.762zm-445.917-37.175 17.345-28.438-9.009-8.339c-28.202-26.103-44.376-63.093-44.376-101.484 0-76.236 62.023-138.26 138.26-138.26s138.261 62.023 138.261 138.26-62.023 138.26-138.261 138.26h-102.22zm277.656 175.435c-76.237 0-138.26-62.023-138.26-138.261 0-3.801.158-7.618.47-11.421 62.61-14.364 112.005-63.76 126.37-126.369 3.804-.312 7.62-.47 11.421-.47 76.237 0 138.261 62.023 138.261 138.26 0 38.391-16.175 75.38-44.377 101.484l-9.009 8.339 17.346 28.438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.924 292.26h30.002v30h-30.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.465 292.26h30.001v30h-30.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.696 387.68c-17.519 0-31.771-14.252-31.771-31.77h-30c0 34.06 27.71 61.77 61.771 61.77 34.06 0 61.77-27.71 61.77-61.77h-30c-.001 17.518-14.253 31.77-31.77 31.77z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseFeedback);
export default __webpack_public_path__ + "static/media/courseFeedback.8ba267792e74902ae34cb83ac903dc46.svg";
export { ForwardRef as ReactComponent };